import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from '@tanstack/react-router';
import { fadeUp, Reveal } from './animations';

const AUDIENCES = [
  { slug: 'projektmanager', de: 'Projektmanager / Scrum Master', en: 'Project Manager / Scrum Master', deSub: 'Stakeholder-Kommunikation & Konflikte', enSub: 'Stakeholder Communication & Conflicts', img: '/img/team-discussion.jpg', imgPos: 'center' },
  { slug: 'engineering-manager', de: 'Engineering Manager', en: 'Engineering Manager', deSub: 'Squad-Forming & Skill-Gaps', enSub: 'Squad Forming & Skill Gaps', img: '/img/engineering-lead.jpg', imgPos: '50% 35%' },
  { slug: 'engineer', de: 'Engineer', en: 'Engineer', deSub: 'Individuelle Schätzungen & Sichtbarkeit', enSub: 'Individual Estimates & Visibility', img: '/img/pair-programming.jpg', imgPos: 'center' },
  { slug: 'freelancer', de: 'Freelancer', en: 'Freelancer', deSub: 'Professionelle Planung ohne Enterprise-Kosten', enSub: 'Professional Planning Without Enterprise Costs', img: '/img/remote-work.jpg', imgPos: '50% 65%' },
] as const;

const text = {
  de: { label: 'Zielgruppen', heading: 'Andere Rolle, andere Perspektive', sub: 'Dieselben Daten — unterschiedliche Sichtweisen. So nutzen verschiedene Rollen qtplan.' },
  en: { label: 'Use Cases', heading: 'Different role, different perspective', sub: 'Same data — different viewpoints. How different roles use qtplan.' },
} as const;

export function LandingAudienceSection({ sectionRef }: { sectionRef?: React.RefObject<HTMLElement | null> }) {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'de';
  const t = text[lang];

  return (
    <section className="landing-audience-section" ref={sectionRef}>
      <Reveal className="landing-audience-inner">
        <motion.p className="landing-section-label" variants={fadeUp} custom={0}>
          {t.label}
        </motion.p>
        <motion.h2 className="landing-section-heading" variants={fadeUp} custom={1}>
          {t.heading}
        </motion.h2>
        <motion.p className="landing-section-sub" variants={fadeUp} custom={2}>
          {t.sub}
        </motion.p>
        <motion.div className="landing-audience-grid" variants={fadeUp} custom={3}>
          {AUDIENCES.map((a) => (
            <Link key={a.slug} to={`/${lang}/for/${a.slug}`} className="landing-audience-card">
              <div className="landing-audience-card-img">
                <img src={a.img} alt="" loading="lazy" style={{ objectPosition: a.imgPos }} />
              </div>
              <div className="landing-audience-card-body">
                <span className="landing-audience-card-role">{lang === 'de' ? a.de : a.en}</span>
                <span className="landing-audience-card-desc">{lang === 'de' ? a.deSub : a.enSub}</span>
              </div>
            </Link>
          ))}
        </motion.div>
      </Reveal>
    </section>
  );
}
